import { render, staticRenderFns } from "./dispatchBill.vue?vue&type=template&id=33adb672&"
import script from "./dispatchBill.vue?vue&type=script&lang=js&"
export * from "./dispatchBill.vue?vue&type=script&lang=js&"
import style0 from "./dispatchBill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports